import { createContext, ReactNode, useContext, useState } from "react";
import { cva } from "class-variance-authority";
import { Nil } from "cy-util";

export interface InputGroupProps {
  className?: string;
  children: ReactNode;
  "data-testid"?: string;
}

export type InputGroupContextType =
  | {
      leftWidth: number | Nil;
      setLeftWidth: (width: number) => void;
      rightWidth: number | Nil;
      setRightWidth: (width: number) => void;
    }
  | Nil;
const InputGroupContext = createContext<InputGroupContextType | Nil>(null);

export function useInputGroupContext() {
  const context = useContext(InputGroupContext);
  // if (context == null) {
  //   throw new Error("InputGroupContext has no context provider set");
  // }
  return context;
}

const styles = cva("relative flex items-center justify-stretch");
/**
 *
 */
const InputGroupRoot = ({
  className,
  children,
  "data-testid": dataTestId,
}: InputGroupProps) => {
  const [leftWidth, setLeftWidth] = useState<number>();
  const [rightWidth, setRightWidth] = useState<number>();
  const testId = dataTestId || "input-group";

  return (
    <InputGroupContext.Provider
      value={{ leftWidth, setLeftWidth, rightWidth, setRightWidth }}
    >
      <div className={styles({ className })} data-testid={testId}>
        {children}
      </div>
    </InputGroupContext.Provider>
  );
};

export const InputGroup = Object.assign(InputGroupRoot, {});
